import { Datetime } from "components/shared/form";
import { formatDate } from "helpers/date";
import React from "react";

type MonthPickerProps = {
    month: string;
    disabled?: boolean;
    onChange: (month: string) => void;
};

export default function MonthPicker({ month, disabled = false, onChange }: MonthPickerProps) {
    const changeMonth = (value: string) => {
        const nextMonth = formatDate(value)?.slice(0, 7);
        if (nextMonth) {
            onChange(nextMonth);
        }
    };

    return (
        <Datetime
            inputProps={{ name: "performancePlanMonth", type: "custom", disabled }}
            value={`${month}-01T00:00:00`}
            onChange={({ value }: { value: string }) => changeMonth(value)}
            format={{ dateFormat: "LLLL yyyy", showMonthYearPicker: true }}
            libOptions={{ dateFormat: "LLLL yyyy", showMonthYearPicker: true }}
            wrapper="performance-plans__month-picker"
            bWrapper="mb-0"
            inPortal
        />
    );
}
